import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { AuthService } from '../shared/libs/auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class ImageService {
	readonly #appService = inject(AppService);
	readonly #httpClient = inject(HttpClient);
	readonly #authService = inject(AuthService);
	private baseUrl: string = this.#appService.utilsUrls.apiUrl;

	/*metodo per scaricare dalla parte di style */
	DownloadImagesByModelIds(_modelIds: number[]): Observable<Blob> {
		const token = this.#authService.getTokenValue;

		return this.#httpClient.post(
			`${this.baseUrl}/Company/DownloadImagesByModelIds`,
			{ modelIds: _modelIds },
			{
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
	}

	/*metodo per scaricare dalla parte di ordini */
	downloadImagesByShotIds(_shotIds: number[]): Observable<Blob> {
		const token = this.#authService.getTokenValue;

		return this.#httpClient.post(
			`${this.baseUrl}/Company/DownloadImagesByShotIds`,
			{ shotIds: _shotIds },
			{
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
	}

	/*metodo per scaricare dalla parte degli style*/
	downloadImagesByImageIds(_imageIds: number[]): Observable<Blob> {
		const token = this.#authService.getTokenValue;

		return this.#httpClient.post(
			`${this.baseUrl}/Company/DownloadImagesByImageIds`,
			{ imageIds: _imageIds },
			{
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
	}

	/*metodo per scaricare dalla parte degli ordini*/
	downloadImagesByOrderIds(_orderIds: number[]): Observable<Blob> {
		const token = this.#authService.getTokenValue;

		return this.#httpClient.post(
			`${this.baseUrl}/Common/DownloadImagesByOrderIds`,
			{ orderIds: _orderIds },
			{
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
	}

	downloadImagesByMediaShareLinkId(_mediaShareLinkId: string): Observable<Blob> {
		return this.#httpClient.post(
			`${this.baseUrl}/Company/DownloadImagesByMediaShareLinkId`,
			{ mediaShareLinkId: _mediaShareLinkId },
			{
				responseType: 'blob'
			}
		);
	}
}
